export default "__VITE_ASSET__Ckpf7ATm__"